import { SET_SELECTED_TIMEZONE, SET_SIDEBAR_STATUS, SET_STUDIO_RIGHT_PANEL_STATUS } from './mutation-types';

export default {
  [SET_SELECTED_TIMEZONE](state, timezone) {
    state.selectedTimezone = timezone;
  },

  [SET_SIDEBAR_STATUS](state, isOpened) {
    state.isSidebarOpen = isOpened;
  },

  [SET_STUDIO_RIGHT_PANEL_STATUS](state, isOpened) {
    state.showStudioRightPanel = isOpened;
  },
};
